import React from 'react';
import { Link } from 'react-router-dom';
import mdu from '../assets/MDUsmall.png';

const MDU = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Multi-Dwelling Unit (MDU) Connectivity</h1>

        <img src={mdu} alt="MDU Connectivity" style={{
          width: '100%', maxWidth: '600px', borderRadius: '12px', marginBottom: '30px'
        }} />

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>The Challenge</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          In multi-dwelling units, reliable wireless connectivity is not a luxury but a necessity.
          Many operators face challenges managing and supporting their wireless networks effectively,
          leading to service disruptions, sluggish connections, and increased costs. Residents expect
          consistent, high-speed internet as a baseline amenity.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Our Solution</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Managed WiFi services extend robust wireless internet access to all occupants. By implementing
          a community-wide MDU network, operators provide a sought-after amenity that attracts tenants,
          boosts revenues, and differentiates their properties from competitors.
        </p>

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '40px', fontSize: '1.1rem' }}>
          With Sarvanta's Cloud NaaS solutions, MDU operators gain centralized control and visibility
          through a single pane of glass. Our AI-based radio management ensures efficient network
          operation, seamless coverage, and an enhanced resident experience — all while optimizing
          costs and ensuring long-term reliability.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Why Sarvanta for MDU</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          {[
            { title: 'Revenue Generation', desc: 'Turn WiFi from a cost center into a revenue stream with tiered service plans and premium connectivity options.' },
            { title: 'Tenant Attraction', desc: 'High-quality managed WiFi is a top amenity for prospective tenants, improving occupancy rates and retention.' },
            { title: 'AI-Optimized Coverage', desc: 'Machine learning ensures every unit receives consistent, reliable coverage regardless of building layout or density.' },
            { title: 'Single Pane of Glass', desc: 'Manage all properties from one cloud dashboard with real-time monitoring, alerts, and reporting.' }
          ].map((item, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
              border: '1px solid #1a2744'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', color: '#60a5fa' }}>{item.title}</h3>
              <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>{item.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px', border: '1px solid #1a2744', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>
            Discover how to enhance your MDU properties with managed WiFi.
          </p>
          <Link to="/whitepapers" style={{
            padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>Download White Paper</Link>
        </div>
      </div>
    </div>
  );
};

export default MDU;
